<template>
  <div class="table-responsive">
    <table class="table table-striped table-sm color-icon-label-table">
      <thead>
      <tr>
        <td></td>
        <td>{{'tables.headings.time' | translate}}</td>
        <td>{{'tables.headings.log' | translate}}</td>
        <td align="middle"></td>
      </tr>
      </thead>
      <tbody>
        <tr 
          v-for="(log, ilog) in returnTableData"
          :key="ilog"
        >
          <td>
            <span class="badge badge-pill" :class="getBadgeClass(log)">{{ log.action }}</span>
          </td>
          <td>{{ log.created_at }}</td>
          <td v-html="'<strong>' + log.who + '</strong>' + ' ' + log.action + ' ' + log.target + ' ' + log.id + ', section ' + log.section"></td>
          <td align="middle" class="valid">
            <i class="fa icon-right input-icon" :class="getIconClass(log)"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'vuestic-log',

    props: {
      section: {
        type: String,
        default: ''
      }
    },

    computed: {
      returnTableData () {
        let d = this.$root.log
        d = d.filter((item) => {
          return item.section === this.section
        })
        return d
      }
    },

    methods: {
      getIconClass (row) {
        return {
          'fa-check success-icon': row.success === true,
          'fa-exclamation-triangle error-icon': row.success === false,
        }
      },
      getBadgeClass (row) {
        return {
          'badge-success': row.action === 'add',
          'badge-info': row.action === 'edit',
          'badge-danger': row.action === 'remove'
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../sass/_variables.scss';
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";
  @import "~bootstrap/scss/mixins/breakpoints";


</style>



// WEBPACK FOOTER //
// src/vuestic-theme/vuestic-components/vuestic-log/VuesticLog.vue